module.exports = __webpack_public_path__ + "static/media/pr.b5382c19.jpg";